import React, { useEffect } from "react";
// components
import { Crearinivitacion } from "./components/Crearinivitacion";
import { CronogramaActividades } from "./components/CronogramaActividades";
import { Documentos } from "./components/Documentos";
// styled components
import { Tabs } from "antd";
// hooks
import { useInfoJurados } from "../../../hooks/useInfoJurados";
// style
import "./infoJurados.style.scss";
import { BreadCrumbAdmin } from "../../../components/Administrador/Breadcrumb/Breadcrumb";
import { useEncrypt } from "../../../hooks/useEncrypt";

export const Infojurados = () => {
  const { principalState, setPrincipalState, onFinish, onChange } =
    useInfoJurados();
  const { decrypt } = useEncrypt();

  // const { cambiarPestaña } = useSelector(
  //   (state: RootState) => state.cambiarPestaña
  // );
  // const { editarConvocatoria } = useSelector(
  //   (state: RootState) => state.edicion
  // );

  const cambiar_pestaña = decrypt(localStorage.getItem("cambiarPestaña"));
  
  let cambiarPestaña = "1";
  if (cambiar_pestaña !== null) {
    cambiarPestaña = cambiar_pestaña;
    
  }

  const editar_convocatoria = decrypt(
    localStorage.getItem("editar_convocatoria")
  );

  let editarConvocatoria = false;
  if (editar_convocatoria !== null) {
    editarConvocatoria = Boolean(editar_convocatoria);
  }

  // useEffect(() => {
  //   if (decrypt(localStorage.getItem("cambiarPestaña"))) {
  //     return setPrincipalState({
  //       ...principalState,
  //       activeTab: decrypt(localStorage.getItem("cambiarPestaña")),
  //     });
  //   }
  // }, [localStorage.getItem("cambiarPestaña")]);

  useEffect(() => {
    if (!editarConvocatoria) {
      return setPrincipalState({ ...principalState, activeTab: "1" });
    } else {
      if (cambiarPestaña !== "1") {
        return setPrincipalState({
          ...principalState,
          activeTab: cambiarPestaña,
        });
      }
    }
  }, []);
  
  const routes = [
    { nombre: "Convocatorias" },
    { nombre: "Crear convocatoria" },
    { nombre: "Jurados" },
  ];
  
  return (
    <>
      <BreadCrumbAdmin routes={routes} />
      <div className="container-fluid bg-white ps-3 pe-3">
        <div className="row">
          <div className="titulo_contenedor_tab font-family-Montserrat-SemiBold font-size-14px">
            Invitación al banco de jurados
          </div>
        </div>
      </div>
      <div className="h-100" style={{ flex: "1 1 auto" }}>
        <Tabs
          defaultActiveKey="1"
          activeKey={principalState.activeTab}
          // onChange={onChange}
          className="height-100 width-100 content-tabs-jurados background-color-FFFFFF tabvs-convocatorias"
        >
          <Tabs.TabPane
            tab="Crear Invitación"
            key="1"
            className="height-100 font-size-14px font-family-Montserrat-Regular container-tabs-infojurados margin-left-infojurados-fisrt-tab background-color-F7FBFF"
          >
            <Crearinivitacion
              cambiarPestaña={setPrincipalState}
              activeItem={principalState}
            />
          </Tabs.TabPane>
          <Tabs.TabPane
            tab="Cronograma Actividades"
            key="2"
            className="height-100 font-size-14px font-family-Montserrat-Regular container-tabs-infojurados background-color-F7FBFF"
          >
            <CronogramaActividades
              cambiarPestaña={setPrincipalState}
              activeItem={principalState}
            />
          </Tabs.TabPane>
          <Tabs.TabPane
            tab="Documentos"
            key="3"
            className="height-100 font-size-14px font-family-Montserrat-Regular container-tabs-infojurados background-color-F7FBFF"
          >
            <Documentos
              cambiarPestaña={setPrincipalState}
              activeItem={principalState}
            />
          </Tabs.TabPane>
        </Tabs>
      </div>
    </>
  );
};
